<template>
<div class="chapter">
<div class="inner_page">
<p><a id="c01"></a></p><a id="c01">
<div class="ct sgc-1">
    CHAPTER 1
  </div>
<div class="cst sgc-1">
    SNACKS &amp; NIBBLES
  </div>
<div class="tx1">
<b>I</b>f you’ve ever thought, “When will I need to make an appetizer?” then let me ask <i>you</i> a question in return: When is there a time an appetizer isn’t appropriate? Think of it as food that’s low on the commitment scale—fewer ingredients and minimal instructions all resulting in a smaller quantity of food. I could eat entire meals made straight from the nibbles in this chapter. In fact, I have.
  </div>
<div class="centerAligned"><img alt="009" class="imgepub" src="Images/andr_9781569759516_oeb_009_r1.jpg"/></div>
<div class="tx">
    So look at these recipes as a smorgasbord of sorts. When you want something to nibble on while walking to class, go for a recipe like the irresistible Bratwursts in a Blanket. Want to feed a study group coming to your dorm? Try Thai Red Curry Deviled Eggs or Mini Tostadas with Beef Brisket. Maybe you just want a plateful of Stuffed Mushrooms to feast on while cramming for an exam. Or serve up Spicy Boneless Chicken Pieces to cheer on a sports team. These recipes will make snack time much more rewarding than just tearing open the bag of chips you have lying around.
  </div>
</a><div><a id="c01">
</a><a id="h1">
</a></div><a id="h1">
<div class="rightAligned"><img alt="010" class="imgepub" src="Images/andr_9781569759516_oeb_010_r1.jpg"/></div>
<h1 class="h1 sgc-2" id="heading_id_2">STUFFED MUSHROOMS</h1>
<div class="atx1g">
<div class="tx1d">
<b>YIELD:</b> 4 servings<br/>
<b>PREP TIME:</b> 10 minutes<br/>
<b>COOKING TIME:</b> 12 minutes
    </div>
<div>
       <br/>
</div>
<div class="tx1d">
<b>2 ounces cream cheese</b><br/>
<b>1/4 (6-ounce) bag baby spinach</b><br/>
<b>2 tablespoons Trader Joe’s</b><br/>
<b>Roasted Red Pepper and</b><br/>
<b>Artichoke Tapenade</b><br/>
<b>8 ounces white mushrooms</b><br/>
<b>Trader Joe’s Grated Parmigiano-</b><br/>
<b>Reggiano cheese (optional)</b>
</div>
</div>
<div class="tx1 sgc-3">
    By removing the stem from a mushroom, you create a portable vessel to stuff with cheesy goodness.
  </div>
<div class="lsl1">
    1. Preheat the oven to 450°F. Spray a baking sheet with cooking spray.
  </div>
<div class="lsl1">
    2. Place the cream cheese and spinach in a microwave-safe bowl. Microwave on high until the cream cheese has softened, 30 seconds to 1 minute. Stir the spinach and cream cheese together, then stir in the tapenade until combined.
  </div>
<div class="lsl1">
    3. Remove the stems from the mushrooms and use a wet paper towel to wipe the outside of each mushroom clean. Spoon the mixture into each cavity and arrange the stuffed mushrooms on the prepared baking sheet.
  </div>
<div class="lsl1">
    4. Bake until the cheese is bubbly and the mushrooms are cooked, 10 to 12 minutes. Sprinkle with Parmigiano-Reggiano, if desired.
  </div>
</a><div><a id="h1">
</a><a id="h2">
</a></div><a id="h2">
<div class="rightAligned"><img alt="011" class="imgepub" src="Images/andr_9781569759516_oeb_011_r1.jpg"/></div>
<h1 class="h1 sgc-2" id="heading_id_3">FRIED CHICKPEAS</h1>
<div class="atx1g">
<div class="tx1d">
<b>YIELD:</b> 4 servings<br/>
<b>PREP TIME:</b> 5 minutes<br/>
<b>COOKING TIME:</b> 10 minutes
    </div>
<div>
       <br/>
</div>
<div class="tx1d">
<b>1/4 cup cornstarch</b><br/>
<b>1/4 cup flour</b><br/>
<b>1 teaspoon kosher salt plus</b><br/>
<b>more for sprinkling</b><br/>
<b>1 (15-ounce) can chickpeas,</b><br/>
<b>drained</b><br/>
<b>canola oil, as needed</b>
</div>
</div>
<div class="tx1 sgc-3">
    Whether you call them chickpeas or garbanzo beans, they’re still delicious. The crispy fried coating gives way to the smooth softness of the beans in this vegan snack.
  </div>
<div class="lsl1">
    1. Line a plate with a paper towel. In a large bowl, combine the cornstarch, flour, and salt. Working in batches, add the chickpeas to the cornstarch mixture, coating thoroughly.
  </div>
<div class="lsl1">
    2. Toss the coated chickpeas into a strainer, shaking to remove excess coating.
  </div>
<div class="lsl1">
    3. In a large heavy deep pan, heat 1 inch of oil over high heat until shimmering.
  </div>
<div class="lsl1">
    4. When the oil is hot, add half the chickpeas and cook until crisp, 3 to 4 minutes. Transfer with a slotted spoon onto the prepared plate. Repeat with the remaining chickpeas. Sprinkle salt over the fried chickpeas.
  </div>
<div class="centerAligned"><img alt="012" class="imgepub" src="Images/andr_9781569759516_oeb_012_r1.jpg"/></div>
<div class="centerAligned"><img alt="013" class="imgepub" src="Images/andr_9781569759516_oeb_013_r1.jpg"/></div>
</a><div><a id="h2">
</a><a id="h3">
</a></div><a id="h3">
<div class="rightAligned"><img alt="014" class="imgepub" src="Images/andr_9781569759516_oeb_014_r1.jpg"/></div>
<h1 class="h1 sgc-2" id="heading_id_4">OLIVE FOCACCIA</h1>
<div class="atx1g">
<div class="tx1d">
<b>YIELD:</b> 4 servings<br/>
<b>PREP TIME:</b> 10 minutes<br/>
<b>COOKING TIME:</b> 30 minutes
    </div>
<div>
       <br/>
</div>
<div class="tx1d">
<b>flour, as needed</b><br/>
<b>1 ball Trader Joe’s pizza dough,</b><br/>
<b>at room temperature</b><br/>
<b>1 tablespoon olive oil,</b><br/>
<b>plus more as needed</b><br/>
<b>3 tablespoons Trader Joe’s Olive</b><br/>
<b>Tapenade Spread, divided</b><br/>
<b>2 Roma tomatoes,</b><br/>
<b>thinly sliced lengthwise</b><br/>
<b>1/2 teaspoon kosher salt</b>
</div>
</div>
<div class="tx1 sgc-3">
    The great thing about tapenade is that all the work’s been done for you and it can be used in many ways. Here, it’s merged with pizza dough for an easy vegan focaccia.
  </div>
<div class="lsl1">
    1. Preheat the oven to 400°F.
  </div>
<div class="lsl1">
    2. Sprinkle 1 to 2 tablespoons flour onto a cutting board. Place the pizza dough on the cutting board and gently knead it. Then gently stretch the dough out with your fingers.
  </div>
<div class="lsl1">
    3. In an 8 x 12-inch glass baking dish, combine the oil and 1 tablespoon olive tapenade, and spread the mixture around the bottom of the dish.
  </div>
<div class="lsl1">
    4. Spread the pizza dough over the olive oil and tapenade, pressing the dough down into the bottom of the dish. Use your fingers to punch tiny indentations into the top of the dough.
  </div>
<div class="lsl1">
    5. Spread the remaining tapenade on top, then layer tomato slices over the top of the dough and sprinkle with the salt. Bake until the focaccia is puffy and golden, 25 to 30 minutes. Drizzle with olive oil and cut into pieces.
  </div>
</a><div><a id="h3">
</a><a id="h4">
</a></div><a id="h4">
<div class="rightAligned"><img alt="015" class="imgepub" src="Images/andr_9781569759516_oeb_015_r1.jpg"/></div>
<h1 class="h1 sgc-2" id="heading_id_5">TABOULI-STUFFED MINI PITAS</h1>
<div class="atx1g">
<div class="tx1d">
<b>YIELD:</b> 8 to 10 mini pitas<br/>
<b>PREP TIME:</b> 10 minutes
    </div>
<div>
       <br/>
</div>
<div>
       <br/>
</div>
<div class="tx1d">
<b>1/3 (12-ounce) jar Trader Joe’s</b><br/>
<b>Fire-Roasted Red and Yellow</b><br/>
<b>Peppers (about 2 peppers)</b><br/>
<b>3/4 cup Trader Joe’s</b><br/>
<b>Tabouli Salad</b><br/>
<b>3 tablespoons Trader Joe’s</b><br/>
<b>Hummus with Freshly</b><br/>
<b>Ground Horseradish,</b><br/>
<b>or any other hummus</b><br/>
<b>1/4 teaspoon kosher salt</b><br/>
<b>8 to 10 Trader Joe’s Mini Pita</b><br/>
<b>Pockets</b>
</div>
</div>
<div class="tx1 sgc-3">
    Tabouli is a vegan Middle Eastern dish made with bulgur wheat, tomatoes, onions, and parsley tossed in olive oil and lemon juice.
  </div>
<div class="lsl1">
    1. Chop the peppers into small dice.
  </div>
<div class="lsl1">
    2. In a small bowl, stir together the peppers, tabouli, hummus, and salt.
  </div>
<div class="lsl1">
    3. Slice a small opening in the top of each pita and stuff with the tabouli mixture.
  </div>
</a><div><a id="h4">
</a><a id="h5">
</a></div><a id="h5">
<div class="rightAligned"><img alt="016" class="imgepub" src="Images/andr_9781569759516_oeb_016_r1.jpg"/></div>
<h1 class="h1 sgc-2" id="heading_id_6">GUACAMOLE WITH TOMATILLOS</h1>
<div class="atx1g">
<div class="tx1d">
<b>YIELD:</b> 4 servings<br/>
<b>PREP TIME:</b> 5 minutes
    </div>
<div>
       <br/>
</div>
<div>
       <br/>
</div>
<div class="tx1d">
<b>juice of 1/2 lime</b><br/>
<b>1 scallion, chopped</b><br/>
<b>2 tablespoons Trader Joe’s</b><br/>
<b>Organic Tomatillo and Roasted</b><br/>
<b>Yellow Chili Sauce</b><br/>
<b>1/2 jalapeño, seeds and ribs</b><br/>
<b>removed, minced (optional)</b><br/>
<b>1/2 teaspoon kosher salt</b><br/>
<b>2 avocados, diced (for tips on</b><br/>
<b>dicing, see page 152)</b><br/>
<b>tortillas or chips</b>
</div>
</div>
<div class="tx1">
<i>For this vegan guacamole, the avocado is paired with the tangy tomatillos in the salsa verde.</i>
<div class="lsl1">
      1. In a small bowl, whisk together the lime juice, scallion, tomatillo sauce, jalapeño, if using, and salt.
    </div>
<div class="lsl1">
      2. Add the avocado chunks and stir to combine.
    </div>
<div class="lsl1">
      3. Mash the avocado chunks with a fork until it’s your preferred consistency. Serve with tortillas or chips.
    </div>
</div>
</a><div><a id="h5">
</a><a id="h6">
</a></div><a id="h6">
<div class="rightAligned"><img alt="017" class="imgepub" src="Images/andr_9781569759516_oeb_017_r1.jpg"/></div>
<h1 class="h1 sgc-2" id="heading_id_7">BRATWURSTS IN A BLANKET</h1>
<div class="atx1g">
<div class="tx1d">
<b>YIELD:</b> 8 bratwursts in a blanket<br/>
<b>PREP TIME:</b> 10 minutes<br/>
<b>COOKING TIME:</b> 20 minutes
    </div>
<div>
       <br/>
</div>
<div class="tx1d">
<b>2 tablespoons Dijon mustard</b><br/>
<b>1 tablespoon honey</b><br/>
<b>1 (8-ounce) can Trader Joe’s</b><br/>
<b>Crescent Rolls</b><br/>
<b>1 (7-ounce) package Trader</b><br/>
<b>Joe’s Fully-Cooked Bavarian</b><br/>
<b>Bratwurst (8 sausages)</b>
</div>
</div>
<div class="tx1 sgc-3">
    The slight tartness and full porkiness of the Trader Joe’s Bavarian sausages make them fabulously addictive.
  </div>
<div class="lsl1">
    1. Preheat the oven to 375°F. Spray a baking sheet with cooking spray.
  </div>
<div class="lsl1">
    2. In a small bowl, combine the mustard and honey, stirring to thoroughly mix.
  </div>
<div class="lsl1">
    3. Unroll the crescent rolls from their can, placing them on a cutting board with the longest side of each crescent roll toward the bottom. Place a drop of the honey mustard on the bottom part of each crescent roll, followed by a bratwurst on top of the mustard. Set aside the remaining honey mustard.
  </div>
<div class="lsl1">
    4. Starting at the bottom of each roll, roll up the bratwurst in the crescent dough. Place the rolled bratwursts on the prepared baking sheet, making sure they are not touching each other.
  </div>
<div class="lsl1">
    5. Bake until the crescent rolls are golden brown, 18 to 20 minutes. Serve with the remaining honey mustard sauce.
  </div>
</a><div><a id="h6">
</a><a id="h7">
</a></div><a id="h7">
<h1 class="h1 sgc-2" id="heading_id_8">JALAPEÑO CHEESE–STUFFED PEPPERS</h1>
<div class="atx1g">
<div class="tx1d">
<b>YIELD:</b> 24 stuffed pepper halves<br/>
<b>PREP TIME:</b> 10 minutes<br/>
<b>COOKING TIME:</b> 10 minutes
    </div>
<div>
       <br/>
</div>
<div class="tx1d">
<b>1 (1-pint) package Trader Joe’s</b><br/>
<b>Minisweet Peppers</b><br/>
<b>1/2 cup Trader Joe’s Pub Cheese</b><br/>
<b>with Jalapeño</b><br/>
<b>5 to 6 slices Trader Joe’s Fully</b><br/>
<b>Cooked Uncured Bacon</b>
</div>
</div>
<div class="tx1 sgc-3">
    Trader Joe’s pub cheese is made from cheddar, and it’s all-natural yet silky and spreadable.
  </div>
<div class="lsl1">
    1. Preheat the oven to 425°F. Spray a baking sheet with cooking spray.
  </div>
<div class="lsl1">
    2. Cut each mini pepper lengthwise and use a spoon to remove the seeds. Using a spoon, fill the pepper halves with pub cheese, place them on the prepared baking sheet, and bake until the cheese has melted, 5 to 8 minutes.
  </div>
<div class="lsl1">
    3. Meanwhile, arrange the bacon slices between layers of paper towels in a small microwave-safe dish. Microwave on high until crispy, 30 to 45 seconds. Crumble the bacon into bits.
  </div>
<div class="lsl1">
    4. Sprinkle the bacon over the cheesy peppers.
  </div>
</a><div><a id="h7">
</a><a id="h8">
</a></div><a id="h8">
<div class="rightAligned"><img alt="018" class="imgepub" src="Images/andr_9781569759516_oeb_018_r1.jpg"/></div>
<h1 class="h1 sgc-2" id="heading_id_9">THAI RED CURRY DEVILED EGGS</h1>
<div class="atx1g">
<div class="tx1d">
<b>YIELD:</b> 12 deviled eggs<br/>
<b>PREP TIME:</b> 10 minutes
    </div>
<div>
       <br/>
</div>
<div>
       <br/>
</div>
<div class="tx1d">
<b>1 (9.3-ounce) package Trader</b><br/>
<b>Joe’s Cage Free Fresh Hard-</b><br/>
<b>Cooked Peeled Eggs (6 eggs)</b><br/>
<b>2 tablespoons mayonnaise</b><br/>
<b>2 tablespoons Trader Joe’s Thai</b><br/>
<b>Red Curry Sauce</b><br/>
<b>1 teaspoon lime juice</b><br/>
<b>1 scallion, chopped, plus extra</b><br/>
<b>for garnish</b><br/>
<b>1/4 teaspoon kosher salt</b>
</div>
</div>
<div class="tx1 sgc-3">
    The secret ingredient in these babies is Trader Joe’s Thai Red Curry Sauce, which adds an exotic flare.
  </div>
<div class="lsl1">
    1. Cut each hard-cooked egg in half lengthwise. Scoop the yolks out into a small bowl.
  </div>
<div class="lsl1">
    2. Add the mayonnaise, curry sauce, lime juice, scallion, and salt to the bowl with the yolks. Mash the ingredients together until combined.
  </div>
<div class="lsl1">
    3. Spoon the yolk mixture into the egg white halves and garnish with a few pieces of scallion.
  </div>
<div class="chabox tx1">
    Note: If TJ’s hard-cooked eggs are not available, see page 153.
  </div>
<div class="centerAligned"><img alt="019" class="imgepub" src="Images/andr_9781569759516_oeb_019_r1.jpg"/></div>
</a><div><a id="h8">
</a><a id="h9">
</a></div><a id="h9">
<h1 class="h1 sgc-2" id="heading_id_10">SPICY BONELESS CHICKEN PIECES</h1>
<div class="atx1g">
<div class="tx1d">
<b>YIELD:</b> 4 servings<br/>
<b>PREP TIME:</b> 10 minutes<br/>
<b>COOKING TIME:</b> 15 minutes
    </div>
<div>
       <br/>
</div>
<div class="tx1d">
<b>1/4 cup canola oil</b><br/>
<b>1 (22-ounce) package Trader</b><br/>
<b>Joe’s Mandarin Orange Chicken</b><br/>
<b>1/2 cup Trader Joe’s Jalapeño</b><br/>
<b>Pepper Hot Sauce</b><br/>
<b>4 tablespoons unsalted butter</b><br/>
<b>1/4 cup honey</b>
</div>
</div>
<div class="tx1 sgc-3">
    Coating Trader Joe’s Mandarin Orange Chicken in a mixture of hot sauce and butter creates boneless buffalo wings in a snap.
  </div>
<div class="lsl1">
    1. Line a plate with a paper towel. Heat the oil in a large skillet over medium-high heat until shimmering.
  </div>
<div class="lsl1">
    2. Discard the orange sauce from the chicken. Add the chicken pieces to the skillet and cook until crispy, 8 to 10 minutes, turning them over halfway through. Transfer the chicken to the prepared plate.
  </div>
<div class="lsl1">
    3. In a microwave-safe dish, place the hot sauce, butter, and honey. Microwave on high until the butter is melted and the sauce is warm, about 1 minute. Pour the hot sauce mixture into a large bowl along with the chicken pieces. Coat the chicken pieces with the hot sauce.
  </div>
</a><div><a id="h9">
</a><a id="h10">
</a></div><a id="h10">
<div class="rightAligned"><img alt="020" class="imgepub" src="Images/andr_9781569759516_oeb_020_r1.jpg"/></div>
<h1 class="h1 sgc-2" id="heading_id_11">SLOPPY JOE NACHOS</h1>
<div class="atx1g">
<div class="tx1d">
<b>YIELD:</b> 4 servings<br/>
<b>PREP TIME:</b> 5 minutes<br/>
<b>COOKING TIME:</b> 10 minutes
    </div>
<div>
       <br/>
</div>
<div class="tx1d">
<b>1 (12-ounce) package frozen</b><br/>
<b>Trader Joe’s Turkey Bolognese</b><br/>
<b>1 1/2 tablespoons brown sugar</b><br/>
<b>1 tablespoon vinegar</b><br/>
<b>1 tablespoon ketchup</b><br/>
<b>1/2 (11.5-ounce) jar Trader Joe’s</b><br/>
<b>Queso Cheese Dip</b><br/>
<b>1/2 (16-ounce) bag Trader Joe’s</b><br/>
<b>Organic Yellow Corn Tortilla</b><br/>
<b>Chip Rounds</b>
</div>
</div>
<div class="tx1 sgc-3">
    This playful spin on nachos is Super Bowl food at its best.
  </div>
<div class="lsl1">
    1. Microwave the turkey Bolognese according to the package directions.
  </div>
<div class="lsl1">
    2. Carefully remove the Bolognese from the microwave. Add the brown sugar, vinegar, and ketchup to the carton, stirring to combine.
  </div>
<div class="lsl1">
    3. Pour the queso dip into a microwave-safe dish and microwave on high until warm, 2 to 3 minutes.
  </div>
<div class="lsl1">
    4. Layer a plate with the tortilla chips and pour the warm Bolognese mixture over top. Drizzle queso dip over the chips.
  </div>
</a><div><a id="h10">
</a><a id="h11">
</a></div><a id="h11">
<div class="rightAligned"><img alt="021" class="imgepub" src="Images/andr_9781569759516_oeb_021_r1.jpg"/></div>
<h1 class="h1" id="heading_id_12"><b>PINWHEELS <i>with</i> SPINACH</b> <b><i>and</i> PROSCIUTTO</b></h1>
<div class="atx1g">
<div class="tx1d">
<b>YIELD:</b> about 20 pinwheels<br/>
<b>PREP TIME:</b> 10 minutes<br/>
<b>COOKING TIME:</b> 15 minutes
    </div>
<div>
       <br/>
</div>
<div class="tx1d">
<b>1 tablespoon flour</b><br/>
<b>1 (8-ounce) can Trader Joe’s</b><br/>
<b>Crescent Rolls</b><br/>
<b>1 (4-ounce) package Trader Joe’s</b><br/>
<b>Traditional Prosciutto</b><br/>
<b>1/2 cup Trader Joe’s Spinach and</b><br/>
<b>Sour Cream Dip</b>
</div>
</div>
<div class="tx1 sgc-3">
    Italian for “ham,” prosciutto is ham that has been seasoned, salt cured, air dried, and pressed.
  </div>
<div class="lsl1">
    1. Preheat the oven to 400°F. Spray a baking sheet with cooking spray.
  </div>
<div class="lsl1">
    2. Dust a cutting board with the flour. Transfer the crescent dough in one piece from the tube onto the cutting board. Roll the dough out into a rectangle and pinch the creases together.
  </div>
<div class="lsl1">
    3. Layer the dough with 3 pieces of prosciutto, spread the spinach dip in an even layer on top of the prosciutto, then layer 3 more pieces of prosciutto on top.
  </div>
<div class="lsl1">
    4. Roll the dough up into a log, starting with the long side of the rectangle. Cut the log into rounds about 3/4 inch thick. Arrange the pinwheels on the prepared baking sheet so they aren’t touching each other.
  </div>
<div class="lsl1">
    5. Bake until the dough is golden brown, about 15 minutes.
  </div>
<div class="centerAligned"><img alt="022" class="imgepub" src="Images/andr_9781569759516_oeb_022_r1.jpg"/></div>
</a><div><a id="h11">
</a><a id="h12">
</a></div><a id="h12">
<div class="rightAligned"><img alt="023" class="imgepub" src="Images/andr_9781569759516_oeb_023_r1.jpg"/></div>
<h1 class="h1 sgc-2" id="heading_id_13">PORK BUNS <i>with</i> BROCCOLI SLAW</h1>
<div class="atx1g">
<div class="tx1d">
<b>YIELD:</b> 4 pork buns<br/>
<b>PREP TIME</b>: 5 minutes<br/>
<b>COOKING TIME:</b> 5 minutes
    </div>
<div>
       <br/>
</div>
<div class="tx1d">
<b>1 1/2 cups Trader Joe’s Organic</b><br/>
<b>Broccoli Slaw</b><br/>
<b>1/3 cup mayonnaise</b><br/>
<b>1 teaspoon Trader Joe’s Jalapeño<br/>
      Pepper Hot Sauce (optional)</b><br/>
<b>1 teaspoon soy sauce</b><br/>
<b>2 teaspoons white vinegar 3.</b><br/>
<b>1 (8-ounce) package frozen</b><br/>
<b>Trader Ming’s Chinese Style</b><br/>
<b>Pork Buns</b>
</div>
</div>
<div class="tx1">
<i>Barbecued pork and coleslaw are a tasty combo that gets</i> <i>an Asian spin in this recipe.</i>
</div>
<div class="lsl1">
    1. Stir together slaw, mayonnaise, hot sauce, if using, soy sauce, and vinegar in a medium bowl.
  </div>
<div class="lsl1">
    2. Place the pork buns on a microwave-safe dish and cover with a damp paper towel. Microwave on high until warm, about 45 seconds.
  </div>
<div class="lsl1">
    3. Carefully cut off the top one-third of each pork bun, discarding the extra dough. Pile slaw onto the pork buns and serve open-faced.
  </div>
</a><div><a id="h12">
</a><a id="h13">
</a></div><a id="h13">
<div class="rightAligned"><img alt="024" class="imgepub" src="Images/andr_9781569759516_oeb_024_r1.jpg"/></div>
<h1 class="h1 sgc-2" id="heading_id_14">FRITO PIE</h1>
<div class="atx1g">
<div class="tx1d">
<b>YIELD:</b> 4 servings<br/>
<b>PREP TIME:</b> 10 minutes<br/>
<b>COOKING TIME:</b> 5 minutes
    </div>
<div>
       <br/>
</div>
<div class="tx1d">
<b>1/2 (4-ounce) can Trader Joe’s</b><br/>
<b>New Mexico Hatch Valley Fire</b><br/>
<b>Roasted Diced Green Chiles</b><br/>
<b>1/2 cup sour cream</b><br/>
<b>salt</b><br/>
<b>1/2 (15-ounce) can Trader Joe’s</b><br/>
<b>Beef Chili with Beans</b><br/>
<b>1/2 (14 1/2-ounce) bag Trader</b><br/>
<b>Joe’s Organic Corn Chip Dippers</b><br/>
<b>1 cup Trader Joe’s Shredded</b><br/>
<b>Cheddar Cheese</b>
</div>
</div>
<div class="tx1 sgc-3">
    Frito Pie is a Texan dish that pairs corn chips with chili and cheese. This is prime football-watching food.
  </div>
<div class="lsl1">
    1. In a small bowl, combine the green chiles and sour cream. Add salt to taste and stir.
  </div>
<div class="lsl1">
    2. Microwave the chili on high until warm, 2 to 3 minutes.
  </div>
<div class="lsl1">
    3. On a large plate, spread the chips in a single layer. Pour the chili on top of the chips and sprinkle with the cheese. Garnish with dollops of the green chile sour cream.
  </div>
<div class="centerAligned"><img alt="025" class="imgepub" src="Images/andr_9781569759516_oeb_025_r1.jpg"/></div>
</a><div><a id="h13">
</a><a id="h14">
</a></div><a id="h14">
<h1 class="h1" id="heading_id_15"><b>MINI TOSTADAS</b> <i class="sgc-4">with</i> <b>BEEF BRISKET</b></h1>
<div class="atx1g">
<div class="tx1d">
<b>YIELD:</b> 4 servings<br/>
<b>PREP TIME:</b> 10 minutes<br/>
<b>COOKING TIME:</b> 5 minutes
    </div>
<div>
       <br/>
</div>
<div class="tx1d">
<b>1 (16-ounce) package Trader</b><br/>
<b>Joe’s Pulled Beef Brisket in</b><br/>
<b>Smoky BBQ Sauce</b><br/>
<b>1/2 (16-ounce) bag Trader Joe’s</b><br/>
<b>Organic Blue Corn Tortilla Chips</b><br/>
<b>1 cup Trader Joe’s Pimento</b><br/>
<b>Cheese Spread</b>
</div>
</div>
<div class="tx1 sgc-3">
    Tortilla chips are layered with brisket and melted pimento cheese for heavenly mini tostadas.
  </div>
<div class="lsl1">
    1. Preheat the oven to 400°F. Line a rimmed baking sheet with foil.
  </div>
<div class="lsl1">
    2. Microwave the beef brisket according to the package directions.
  </div>
<div class="lsl1">
    3. On the prepared baking sheet, spread a layer of tortilla chips. Using a fork, add a little beef brisket to each chip, followed by a layer of pimento cheese.
  </div>
<div class="lsl1">
    4. Bake until the cheese has melted, about 5 minutes.
  </div>
</a><div><a id="h14">
</a><a id="h15">
</a></div><a id="h15">
<h1 class="h1 sgc-2" id="heading_id_16">SWEET CHILI WINGS</h1>
<div class="atx1g">
<div class="tx1d">
<b>YIELD:</b> 12 wings<br/>
<b>PREP TIME:</b> 5 minutes<br/>
<b>COOKING TIME:</b> 30 minutes
    </div>
<div>
       <br/>
</div>
<div class="tx1d">
<b>12 Trader Joe’s Organic Free</b><br/>
<b>Range Split Chicken Wings</b><br/>
<b>1 teaspoon baking soda</b><br/>
<b>1 teaspoon kosher salt</b><br/>
<b>3/4 cup Trader Joe’s Sweet Chili</b><br/>
<b>Sauce</b><br/>
<b>1/4 cup cold unsalted butter, cut</b><br/>
<b>into pieces</b><br/>
<b>1 tablespoon Trader Joe’s</b><br/>
<b>Jalapeño Pepper Hot Sauce</b><br/>
<b>(optional)</b>
</div>
</div>
<div class="tx1 sgc-3">
    Trader Joe’s has many sauces to inspire your wings, and I enjoy the sweet and spicy flavor of the Sweet Chili Sauce.
  </div>
<div class="lsl1">
    1. Preheat the oven to 425°F. Line a rimmed baking sheet with foil.
  </div>
<div class="lsl1">
    2. Place the wings on the prepared baking sheet, sprinkle with the baking soda and salt, and toss to coat the wings. Spread the wings in a single layer, and bake until the wings are crispy and the meat is fully cooked, 20 to 25 minutes.
  </div>
<div class="lsl1">
    3. Combine the chili sauce, butter, and hot sauce, if using, in a microwave-safe dish. Microwave on high until the butter is melted and the sauce is warm, about 1 minute. Stir.
  </div>
<div class="lsl1">
    4. Transfer the wings to a large bowl and add the sauce. Using a large spoon or tongs, toss the cooked wings with the sauce to coat.
  </div>
<div class="chabox tx1">
    Note: The baking soda makes for a crispier hot wing.
  </div>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// andr_9781569759516_oeb_c01_r1.vue?7a4de68e